// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"189":"3cb241f0","629":"73ef7480"}[chunkId] + ".chunk.css";
};